import { scrollAnimataion } from "./scroll-animataion/scroll-animataion.js";
import { markerSet } from "./marker-set/marker-set.js";
// import { fadeJudge } from "./to-top-btn-fade/to-top-btn-fade.js";


// ===========================================
// 中見出しのインタラクション
// ===========================================
$(function () {
  markerSet($(".interview"));

  $(window).on("scroll", function () {
    markerSet($(".interview"));
  });
});

// ===========================================
// スクロールアニメーションのオプション
// ===========================================
scrollAnimataion({
  className: "interview",
  triggerPoint: 200,
});

// ===========================================
// ページ上部へ戻るボタンのインタラクション
// ===========================================
// $(function () {
//   fadeJudge($(".campaignList__item:nth-child(3)"));
// });

// ===========================================
// 動画のモーダルのインタラクション
// ===========================================
$(function () {
  $(".js-p-interview-detail-movie-video-wrap").each(function () {
    const tmb = $(this),
      modal = $('.movieModal[data-movie-modal="' + tmb.attr("data-movie-modal") + '"]'),
      shadow = modal.find(".movieModalShadow"),
      close = modal.find(".movieModalClose"),
      html = modal.find(".movieModal__box").html();

    tmb.on("click", function () {
      modal.addClass("on");
      $("html").css({ overflow: "hidden" });
    });

    close.on("click", function () {
      modal.removeClass("on");
      $("html").css({ overflow: "auto" });
      modal.find("iframe, img").remove();
      modal.find(".movieModal__box").prepend(html);
      modal.find(".movieModalClose:nth-child(1)").remove();
    });

    shadow.on("click", function () {
      close.click();
    });
  });
});
